module.exports = __webpack_public_path__ + "media/finishLastRiddle.3c49bc1f.mp3";